/**
 * App-boot config. Called once from main.tsx before React mounts.
 */
export const configureHyraxApp = async (): Promise<void> => {
  // Reload on chunk load failure (new deployment): user opened the SPA
  // before a deploy, then navigates to a route whose lazy chunk no
  // longer exists at the old hash. Reloading pulls the fresh entry.
  window.addEventListener('vite:preloadError', () => {
    window.location.reload();
  });
};
